// extracted by mini-css-extract-plugin
export default {"container":"_0U4MC","gridContainer":"lPNh1","headerContainer":"OygGE","header":"TG444","content":"_93SLE","controls":"DXMg4","separator":"_5PhUu"};